import { render, staticRenderFns } from "./EmotionTabs.vue?vue&type=template&id=4693edc8&"
import script from "./EmotionTabs.vue?vue&type=script&lang=js&"
export * from "./EmotionTabs.vue?vue&type=script&lang=js&"
import style0 from "./EmotionTabs.vue?vue&type=style&index=0&id=4693edc8&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports